module.exports = __webpack_public_path__ + "img/TH.9667e838.svg";